<template>
  <div class="popups">
    <div class="popups-cover" />
    <!-- 中奖啦 -->
    <div id="game" class="popups-tcc popups-tcc-winning game">
      <h3>恭喜你获得<span>{{ prizeName }}</span>奖励!</h3>
      请前往游戏查收!
      <a class="tcc-button tcc-button-ok">好的</a>
    </div>

    <!-- 中奖啦 -->
    <div id="winning" class="popups-tcc popups-tcc-winning">
      <h3>恭喜你获得<span>{{ prizeName }}</span>奖励!</h3>
      请前往获奖记录中填写收货信息!
      <a class="tcc-button tcc-button-ok">好的</a>
    </div>

    <!-- 收货信息 -->
    <div id="receipt" class="popups-tcc popups-tcc-receipt">
      <div class="popups-tcc-receipt-form">
        <input id="username" v-model="userNameP" type="text" placeholder="收件人姓名">
        <input id="mobile" v-model="mobilePhone" type="text" placeholder="收件人手机号">
        <input id="address" v-model="addressP" type="text" placeholder="收件人地址">
      </div>
      <p>请确保收货信息正确,否则将无法收到奖品</p>
      <a class="tcc-button tcc-button-fasong">确定</a>
      <a class="tcc-close">关闭</a>
    </div>

    <!-- 提示层1 -->
    <div id="tips1" class="popups-tcc popups-tcc-tips tips1">
      <h3>提交成功！</h3>
      我们将在规定时间内发放奖品！
      <a class="tcc-button tcc-button-ok">好的</a>
    </div>

    <!-- 提示层2 -->
    <div id="tips2" class="popups-tcc popups-tcc-tips tips2">
      <h3>积分不足！</h3>
      前往获取积分吧！
      <a class="tcc-button tcc-button-ok">好的</a>
    </div>

    <!-- 提示层3 -->
    <div id="tips3" class="popups-tcc popups-tcc-tips tips3">
      <h3>您已签到成功！</h3>
      获得2点积分！
      <a class="tcc-button tcc-button-ok">好的</a>
    </div>

    <!-- 提示层4 -->
    <div id="tips4" class="popups-tcc popups-tcc-tips tips4">
      <h3>您已领取成功！</h3>
      获得3点积分！
      <a class="tcc-button tcc-button-ok">好的</a>
    </div>

    <!-- 提示层5 -->
    <div id="tips5" class="popups-tcc popups-tcc-tips tips5">
      <h3>您已领取成功！</h3>
      获得5点积分！
      <a class="tcc-button tcc-button-ok">好的</a>
    </div>

    <!-- 提示层6 -->
    <div id="tips6" class="popups-tcc popups-tcc-tips tips6">
      <h3>谢谢参与！</h3>
      <a class="tcc-button tcc-button-ok">好的</a>
    </div>

    <!-- 获奖记录 -->
    <div id="list" class="popups-tcc popups-tcc-list">
      <div class="recording-list">
        <table cellspacing="0" cellpadding="0" border="0" width="100%">
          <tr>
            <td class="recording-list-clomn1">时间</td>
            <td class="recording-list-clomn2">获得奖励</td>
            <td class="recording-list-clomn3">收货地址</td>
          </tr><tr v-for="item in recordingList" :key="'recording'+item.id">
            <td class="recording-list-clomn1">{{ item.time.replace("2020-","") }}</td>
            <td class="recording-list-clomn2">{{ item.name }}</td>
            <td class="recording-list-clomn3">
              {{ item.type | sendMode }}
              <a v-if="item.type==='1'" :ids="item.id" @click="actionsClick('showTcc', 'receipt','get');handler(item.id);">填写地址 </a>
            </td>
          </tr>
        </table></div>
      <a class="tcc-button tcc-button-ok">确定</a>
    </div>

    <!-- 绑定角色 -->
    <div id="binding" class="popups-tcc popups-tcc-binding">
      <p>每个账号只可绑定一个角色，且无法解绑</p>

      <div class="popups-tcc-receipt-form">
        <div id="setSever" class="select">
          <span class="val" @click="setShow('setSever')">
            {{ selectItem1 }}
          </span>
          <div class="set">
            <a v-for="(item,index) in selectSever" :key="'setSev'+index" :ids="item.id" @click="getVal(item.id,item.name,'setSever')">{{ item.name }}</a>
          </div>
        </div>
        <div id="setCharacter" class="select">
          <span class="val" @click="setShow('setCharacter')">
            {{ selectItem2 }}
          </span>
          <div class="set">
            <a v-for="(item,index) in selectCharacter" :key="'setChar'+index" :ids="item.id" @click="getVal(item.id,item.name,'setCharacter')">{{ item.name }}</a>
          </div>
        </div>
      </div>
      <a class="tcc-button tcc-button-sure" @click="bindRole()">确定</a>
      <a class="tcc-close">关闭</a>
    </div>

    <!-- 微信分享 -->
    <div id="share" class="popups-tcc popups-tcc-share">

      <span class="cai" />
      <span class="tou" />
      <span class="fenx" />
      <span class="shou" />
      <a class="tcc-close">关闭</a>
    </div>
    <Loading v-show="show" />
  </div>
</template>

<script>
import BScroll from 'better-scroll';
import apiFetch from '../api/api';
import Mixins from '../api/Mixins';
import Loading from './Loading.vue';
export default {
  name: 'Popups',
  filters: {
    sendMode(value) {
      let val = (value === '1') ? '' : '邮件发送';
      return val;
    }
  },
  components: {
    Loading
  },
  mixins: [
    Mixins
  ],
  props: {
    recordingList: {
      type: Array,
      default: () => []
    },
    zoneId: {
      type: String,
      default: () => ''
    },
    roleId: {
      type: String,
      default: () => ''
    },
    prizeName: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      show: false,
      selectSever: [
        {
          name: '数据加载中。。。',
          id: '1'
        }
      ], // 选择区服
      selectCharacter: [
        {
          name: '数据加载中。。。',
          id: '0'
        }
      ] // 选择角色
    }
  },
  mounted() {
    let _this = this;
    this.$nextTick(function() {
      // 获奖记录
      let recordbscroll = new BScroll(document.querySelector('.recording-list'), {
        probeType: 3,
        click: true, // 设为 true 表示可以在的 div 里面 实现点击事件
        pullUpLoad: true, // 表示上拉加载更多
        scrollbar: {
          fade: true,
          interactive: false // 1.8.0 新增
        }
      });
      recordbscroll.refresh();
      // 填写地址
      document.querySelector('.tcc-button-fasong').addEventListener('click', function() {
        const rname = document.getElementById('username').value;
        const rmobile = document.getElementById('mobile').value;
        const addrs = document.getElementById('address').value;
        const alogid = _this.addressId;

        if (rname === '') {
          alert('请填写自己姓名');
          return false;
        }
        if (rmobile === '') {
          alert('请填写手机号');
          return false;
        }

        if (!rmobile.match(/^(((1[0-9][0-9]))+\d{8})$/)) {
          alert('手机号码格式不正确！');
          return false;
        }

        if (addrs === '') {
          alert('请填写正确地址');
          return false;
        }

        apiFetch.saveAddress(_this, {
          alogid,
          rname,
          rmobile,
          addrs
        })
      });
    })
  },
  methods: {
    handler(id) {
      // this.$emit('handler', msg);
      this.addressId = id;
      apiFetch.getAddr(this);
    },
    setShow(elm) {
      apiFetch.getCfg(this); // 基础配置
      document.querySelector('#' + elm).getElementsByClassName('set')[0].className += ' on';
    },
    getVal(id, name, elm) {
      var element = document.querySelector('#' + elm).getElementsByClassName('set')[0];
      element.className = element.className.replace(' on', '');

      if (elm === 'setSever') {
        this.zoneId = id;
        this.selectItem1 = name;
        apiFetch.getRole(this);
      } else {
        this.selectItem2 = name;
        this.roleId = id;
      }
    },
    bindRole() {
      apiFetch.bindRole(this); // 绑定角色
    }
  }
};
</script>

<style lang="stylus" scoped>
  .popups-cover
    display none
    position fixed
    width 100%
    height 100%
    left 0
    top 0
    bottom 0
    right 0
    background #000
    opacity 0.8
    z-index 2
  .popups-cover.on
    display block
  .popups-tcc
    visibility hidden
    position absolute
    width 647px
    text-align center
    left 50%
    top 50%
    font-size 28px
    color #bd0d04
    transform translate(-50%,-50%) scale(0)
    background url(../images/tcc.png) no-repeat
    z-index 2
    transition-timing-function cubic-bezier(0.175, 0.885, 0.32, 1.275)
    .popups-tcc-receipt-form
      position relative
      z-index 1
  .popups-tcc-winning
    h3
      span
        font-size 46px
        color #7c2636
        margin 0 10px;
  #receipt
    z-index 3
  .popups-tcc.on
    visibility visible
    transition-duration 0.6s
    transform translate(-50%,-50%) scale(1)
  .tcc-close
    position absolute
    width 59px
    height 100px
    bottom -99px
    left 50%
    overflow hidden
    text-indent -999px
    transform translateX(-50%)
    background url(../images/close.png) no-repeat 0 bottom
  .popups-tcc-winning
    height 557px
    h3
      padding 240px 0 0
      font-size 38px
  .popups-tcc-receipt
    height 465px
    padding 135px 0 0
    background-position 0 -572px
    input
      width 429px
      height 67px
      border solid 1px #c63622
      background #fff
      line-height 67px
      font-size 28px
      color #848181
      text-indent 20px
      margin-bottom 18px
    p
      color #bd0d04
      font-size 24px
  .popups-tcc-tips
    background-position 0 -1182px
    height 457px
    z-index 3
    h3
      padding 158px 0 0
  .popups-tcc-list
    background-position 0 -1667px
    height 486px
    padding 128px 0 0
    .recording-list
      position relative
      width 590px
      height 330px
      overflow hidden
      margin 0 auto
      table
        width 100%
        font-size 28px
        border-top solid 1px #cf2920
        border-left solid 1px #cf2920
        tr
          td
            height 80px
            background #fff
            border-bottom solid 1px #cf2920
            border-right solid 1px #cf2920
          a
            display inline-block
            width 170px
            height 50px
            text-align center
            line-height 50px
            background #cf2920
            color #fff
          .recording-list-clomn1
            width 143px
          .recording-list-clomn2
            width 220px
          .recording-list-clomn3
            width 220px
        tr:nth-child(1) td
          height 68px
          background none
  .popups-tcc-binding
    background-position 0 -2288px
    height 520px
    p
      padding 132px 0 0
      height 36px
      font-size 24px
  @keyframes spin
    0%
      transform rotate(0deg);
    100%
      transform rotate(360deg);

  @keyframes spinoff
    0%
      transform rotate(0deg);
    100%
      transform rotate(-360deg);
</style>
